import React from 'react'
import CustomAsyncSelect from '../form_components/CustomAsyncSelect'
import { useReports } from '../../hooks/useReports'


/**
 * ReportSelector handles the initial discovery of reports.
 * It maps the 'title' from ReportResource to the dropdown label 
 */
const ReportSelector = ({ name, control, rules }) => {

    const {searchReport} = useReports()
    
    // This function fetches the reports from api/search/reports 
    const loadReports = async (inputValue) => {
      if (!inputValue) return [];

      try {
        const reports = await searchReport(inputValue);

        return reports.map((report) => ({
          label: report.title,
          value: report, // Allows ReportPage to access report.parameters 
          ...report // Spread the rest for easy access 
        })); 

      } catch (error) {
        return [];
      }
    }
  return (
    <div className='report-selector-wrapper'>
        <CustomAsyncSelect
            name={name}
            control={control}
            loadOptions={loadReports}
            rules={rules}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value.id}
            placeholder="Search for a report title (e.g., Late Arrival)..."
        />

    </div>
  )
}

export default ReportSelector